export const driverAccountKey=state=>{
 const user=state?.auth?.user;if(!user||state.auth.isAuthenticated===false)return null;
 const id=user.id??user.customerId??user.driverId??user.userId;return id===undefined?null:String(user.role||'').toUpperCase()+':'+String(id);
};
export function withDriverAccountIsolation(reducer){return(state,action)=>{
 const next=reducer(state,action);
 if(state&&driverAccountKey(state)!==driverAccountKey(next)){
  // Reset account-specific in-memory data and request IDs; late responses are rejected by slices.
  if(driverAccountKey(state)&&typeof window!=='undefined'){try{for(const key of ['landingBookingFlow','landingRouteDraft','landingSelectedVehicle','pendingTrackDeliveryId','pendingTrackDeliveryIds'])window.sessionStorage.removeItem(key);}catch{/* No financial recovery data is removed here. */}}
  const reset={...next};for(const key of ['driver','wallet','delivery','payment'])if(key in reset)reset[key]=undefined;
  return reducer(reset,{type:'driver/accountChanged'});
 }
 return next;
};}

export function withAccountRequestGuard(reducer,prefix){return(state,action)=>{
 const match=new RegExp('^'+prefix+'/.*'+String.fromCharCode(47)+'(pending|fulfilled|rejected)$').exec(action.type||'');
 if(!match||!action.meta?.requestId)return reducer(state,action);
 const operation=action.type.slice(0,action.type.lastIndexOf('/')),phase=match[1];
 if(phase!=='pending'&&state?.accountRequestIds?.[operation]!==action.meta.requestId)return state;
 const next=reducer(state,action),requests={...(next.accountRequestIds||{})};if(phase==='pending')requests[operation]=action.meta.requestId;else delete requests[operation];return {...next,accountRequestIds:requests};
};}
